import React from "react"
import { Link } from "gatsby"

import { getSafeDataMap } from "@jsUtils"
import { URLS } from "@data"

const LinkList = props => {
  const { links, current, onStyle } = props

  return getSafeDataMap(links, i => {
    if (i.slug === current) {
      return (
        <li className={onStyle} key={i.id}>
          <Link to={URLS.SUPPORT(i.slug)}>{i.title}</Link>
        </li>
      )
    }
    return (
      <li key={i.id}>
        <Link to={URLS.SUPPORT(i.slug)}>{i.title}</Link>
      </li>
    )
  })
}

export default LinkList
